import { FunctionComponent } from 'preact';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '../../../common/components/icon/icon';
import { MORE_VIDEOS_ICON_TYPES } from '../icon/iconMapper';
import { useStyles } from '../../../common/hooks/useStyles';
import { getMoreVideosButtonStyleObject } from './moreVideosButton.style';
import { MORE_VIDEOS_PLUGIN_MORE_VIDEOS_TEXT } from '../moreVideos.constants';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { css } from '../../../common/styles/styles.utils';
import { setShowGalleryView, setUserInteraction } from '../store/moreVideos.actions';
import {
  getInsideGalleryMoreVideosButtonId,
  getOutsideGalleryMoreVideosButtonId
} from '../htmlElements/htmlElementsIdGetter';

const ARIA_LABEL = 'More videos';

interface MoreVideosButtonVariablesProps {
  insideGallery?: boolean;
  setExitGalleryView?: (value: boolean) => void;
}

export const MoreVideosButton: FunctionComponent<MoreVideosButtonVariablesProps> = props => {
  const { insideGallery = false, setExitGalleryView } = props;

  const dispatch = useDispatch();
  const playerSize = useSelector(playerDataSelector.playerSize);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);

  const outsideGalleryIcon = playerSize === 'medium'
    ? MORE_VIDEOS_ICON_TYPES.MORE_VIDEOS_SMALL_ICON_AND_TEXT : MORE_VIDEOS_ICON_TYPES.MORE_VIDEOS_BIG_ICON_AND_TEXT;
  const styles = useStyles(getMoreVideosButtonStyleObject, [playerSize]);
  const { buttonWrapperStyle, buttonStyle, buttonTextStyle } = styles;

  const onMoreVideosClicked = (e: MouseEvent): void => {
    e.stopPropagation();
    dispatch(setShowGalleryView(!insideGallery));
    if (setExitGalleryView) {
      setExitGalleryView(true);
      dispatch(setUserInteraction('moreVideosClosed'));
    } else {
      dispatch(setUserInteraction('moreVideosIconClicked'));
    }
  };

  const onMoreVideosKeyDown = (event: any): void => {
    if (event.key === 'Enter') {
      onMoreVideosClicked(event);
    }
  };

  return (
    insideGallery
      ? (
        <div
          id={getInsideGalleryMoreVideosButtonId(playerUniqueId)}
          style={css(buttonWrapperStyle)}
          onClick={onMoreVideosClicked}
        >
          <Icon icon={MORE_VIDEOS_ICON_TYPES.MORE_VIDEOS_ICON} ariaLabel={ARIA_LABEL} onKeyDown={onMoreVideosKeyDown} />
          <span style={buttonTextStyle}>
            {MORE_VIDEOS_PLUGIN_MORE_VIDEOS_TEXT}
          </span>
        </div>
      )
      : (
        <Icon
          id={getOutsideGalleryMoreVideosButtonId(playerUniqueId)}
          icon={outsideGalleryIcon}
          onClick={onMoreVideosClicked}
          style={css(buttonStyle)}
          ariaLabel={ARIA_LABEL}
        />
      )
  );
};
